import { planFragment } from './plan-fragment';

export const enrollUtilitySubscriptionQuery = `
  mutation enrollUtilitySubscription($input: EnrollUtilitySubscriptionInput!) {
    enrollUtilitySubscription(input: $input) {
      details {
        depositText,
        finalStatus,
        fullName,
        nextStepsText,
        providerData,
        providerName,
        serviceAddress,
        switchDate,
        phone,
        userEmail
      }
      partnerOrderId,
      providerOrderId,
      status,
      plan {
        ...${planFragment.name}
      }
    }
  }
  ${planFragment.fragment}
`;
// For now we don't really need to select the details from this plan query,
// because we already have them in our state.
